import { render, staticRenderFns } from "./items-slide-b1.vue?vue&type=template&id=29dd61e9&scoped=true&"
import script from "./items-slide-b1.vue?vue&type=script&lang=js&"
export * from "./items-slide-b1.vue?vue&type=script&lang=js&"
import style0 from "./items-slide-b1.vue?vue&type=style&index=0&id=29dd61e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd61e9",
  null
  
)

export default component.exports